import {RowSelectionState} from "@tanstack/react-table";

export const transformIdsToRowSelectionState = (ids: string[] = []) => {
    return ids.reduce((acc, currentId) => {
        acc[currentId] = true;
        return acc;
    }, {} as RowSelectionState);
};
import {RowSelectionState} from "@tanstack/react-table";

export const transformIdsToRowSelectionState = (ids: string[] = []) => {
    return ids.reduce((acc, currentId) => {
        acc[currentId] = true;
        return acc;
    }, {} as RowSelectionState);
};
